/**
 * @link https://gist.github.com/6174/6062387?permalink_comment_id=3020429#gistcomment-3020429
 */
export default (() => {
    const gen = (min, max) => max++ && [...new Array(max - min)].map((s, i) => String.fromCodePoint(min + i)),
        sets = {
            num: gen(48, 57),
            alphaLower: gen(97, 122),
            alphaUpper: gen(65, 90),
            // special: [...'~!@#$%^&*()_+-=[]\{}|;:\'",./<>?'],
        };

    function* iter(len, set) {
        if (set.length === 0) {
            set = Object.values(sets).flat();
        }
        for (let i = 0; i < len; i++) {
            yield set[(Math.random() * set.length) | 0];
        }
    }

    return Object.assign((len, ...set) => [...iter(len, set.flat())].join(''), sets);
})();
